const formSubmit = {
    bindHandler() {
        $('.prevent-multiple-submit').on('submit', (evt) => {
            let self = evt.currentTarget;
            $(self).find('[type="submit"]').prop('disabled', true);
        });
    }
};

$(() => {
    formSubmit.bindHandler();
});

export default formSubmit;
